// Header offset before GlobalUI publishes one: the desktop bar (56) + banner (32).
export const GIFTING_HEADER_FALLBACK_PX = 88;
